import { render, staticRenderFns } from "./SendReferral.vue?vue&type=template&id=a0b6bb04&"
import script from "./SendReferral.vue?vue&type=script&lang=js&"
export * from "./SendReferral.vue?vue&type=script&lang=js&"
import style0 from "./SendReferral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports